import { Eye, EyeOff } from "lucide-react";

type Props = {
  showPass: boolean;
  onToggle: () => void;
};

export const PasswordVisibilityToggle = ({ showPass, onToggle }: Props) => (
  <button
    type="button"
    onClick={onToggle}
    className="bg-transparent border-none cursor-pointer p-0 flex text-[#9CA3AF]"
    aria-label={showPass ? "Hide password" : "Show password"}
  >
    {showPass ? (
      <Eye size={16} color="#9CA3AF" strokeWidth={2} />
    ) : (
      <EyeOff size={16} color="#9CA3AF" strokeWidth={2} />
    )}
  </button>
);
